import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import OptionWithChildren from './OptionWithChildren/OptionWithChildren'
import { isOptionSelected } from './helpers'
import * as Styles from './styles'

const Option = ({ option, currentPath }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const hasSomeChildrenSelected = option?.children?.some(child => isOptionSelected(currentPath, child.link))
  const isParentSelected = isOptionSelected(currentPath, option?.link) || hasSomeChildrenSelected

  return (
    <>
      {option?.children?.length > 0 ? (
        <OptionWithChildren option={option} isParentSelected={isParentSelected} currentPath={currentPath} />
      ) : (
        <Styles.Option selected={isParentSelected}>
          <Styles.OptionLink to={option?.link}>
            {option?.Icon && (
              <option.Icon
                weight={isParentSelected ? option?.iconWeights.selected : option.iconWeights.default}
                color={isParentSelected ? theme.colors.outline.default : theme.colors.text.default}
                size="24"
              />
            )}
            <Text tag="p" type={isParentSelected ? 'bodyMBold' : 'bodyMRegular'}>
              {t(option?.label)}
            </Text>
          </Styles.OptionLink>
        </Styles.Option>
      )}
    </>
  )
}

export default Option
